export default "__VITE_ASSET__o4iqn_bR__"